import { defineFeature } from "../../app/feature";
import { SourceExplorerPage } from "./SourceExplorerPage";

/** Source explorer (task 4040.9): original inventory, parsed hierarchy, anchors, findings,
 * access restrictions, and exact source previews. Owned by the parsers lane. Content follows
 * the API's preview policy; this permission only admits engagement readers to the page. */
export default defineFeature({
  id: "source-explorer",
  title: "Source explorer",
  routes: [{ path: "/source-explorer", Component: SourceExplorerPage }],
  nav: { label: "Source explorer", path: "/source-explorer", section: "Sources", order: 20 },
  permissions: ["engagement.read"],
});
